// Find matches
let mql = window.matchMedia("(orientation: portrait)");

// If there are matches, we're in portrait
// if(mql.matches) {
//     // Portrait orientation
// } else {
//     // Landscape orientation
// }

// Add a media query change listener
mql.addListener(function(m) {
    if(m.matches) {
        // Changed to portrait
        $(window).trigger('orientation:portrait');
    }
    else {
        // Changed to landscape
        $(window).trigger('orientation:landscape');
    }
});


// WEBPACK FOOTER //
// ./_src/js/orientation.js